enum ActionType {
    REQUEST_FILTER = '[VESSEL MANAGEMENT FILTER] REQUEST FILTER',
    RECEIVE_FILTER = '[VESSEL MANAGEMENT FILTER] RECEIVE FILTER',
    TOGGLE_VESSEL_DEPLOYMENT_STATUS = '[VESSEL MANAGEMENT FILTER] TOGGLE VESSEL DEPLOYMENT STATUS',
    RESET_FILTER = '[VESSEL MANAGEMENT FILTER] RESET FILTER',
}

export default ActionType
